import React from 'react';

/*
 * LE ICONE DELLA RIGA DEI GIOCHI, disegnate dentro la pagina.
 *
 * Prima erano sei file in public/assets caricati con <img>: sagome piene con
 * il colore #C8C8C8 scritto dentro il file. Un'immagine caricata cosi' non
 * puo' prendere il colore del testo che accompagna, e per accendere quella
 * attiva serviva questo, in Header.css:
 *
 *     filter: invert(67%) sepia(83%) saturate(1972%)
 *             hue-rotate(157deg) brightness(120%) contrast(112%);
 *
 * cioe' il colore dell'accento riscritto a mano come rotazione di tinta.
 * Cambia l'accento della skin e quel filtro resta dov'e': l'icona attiva
 * resta del colore di un'altra skin. Scritte qui dentro, le icone usano
 * currentColor e seguono da sole la voce - spenta, sotto il mouse, o attiva -
 * senza filtri, senza sei richieste al server, e senza un set di file per
 * ogni skin.
 *
 * Disegno a tratto e non piene: una fila di sagome piene pesa quanto le
 * parole e si mette a litigare con l'unica cosa che deve farsi notare, cioe'
 * dove sei.
 */

// Le icone che si possono disegnare a 16px senza diventare una macchia:
// poche linee, niente dettagli che a quella misura spariscono.
const DISEGNI = {
  // La casa: la vetrina. Sta prima di tutto perche' e' da dove si parte.
  home: (
    <>
      <path d="M4 11l8-7 8 7" />
      <path d="M6 10v10h12V10" />
      <path d="M10 20v-6h4v6" />
    </>
  ),
  sport: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 6.7l4.25 3.1-1.62 5H9.37l-1.62-5z" />
      <path d="M12 3v3.7M19.55 9.5l-3.3 2.3M16.63 19.3l-1.25-4.5M7.37 19.3l1.25-4.5M4.45 9.5l3.3 2.3" />
    </>
  ),
  // Il cronometro dice "sta correndo adesso", che e' l'unica differenza vera
  // fra questa voce e Sport.
  livesport: (
    <>
      <circle cx="12" cy="13.5" r="7" />
      <path d="M12 13.5V10" />
      <path d="M9.5 3h5" />
      <path d="M12 3v3.5" />
    </>
  ),
  livecasino: (
    <>
      <circle cx="12" cy="12" r="8.6" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M12 9.5V5.6M12 14.5v3.9M9.5 12H5.6M14.5 12h3.9M13.8 10.2l2.8-2.8M10.2 10.2L7.4 7.4M13.8 13.8l2.8 2.8M10.2 13.8l-2.8 2.8" />
    </>
  ),
  casino: (
    <>
      <rect x="3.6" y="3.6" width="16.8" height="16.8" rx="3.8" />
      <circle cx="8.3" cy="8.3" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15.7" cy="15.7" r="1.5" fill="currentColor" stroke="none" />
    </>
  ),
  // Due carte, una dietro l'altra. Il seme a 16px diventa una macchia: resta
  // un segno solo al centro.
  poker: (
    <>
      <rect x="2.9" y="7.2" width="8.6" height="12.8" rx="1.9" transform="rotate(-20 7.2 13.6)" />
      <rect x="11.3" y="4" width="9.6" height="16" rx="2.1" />
      <circle cx="16.1" cy="12" r="1.6" fill="currentColor" stroke="none" />
    </>
  ),
  // Uno schermo col triangolo del via: e' una partita simulata, non una
  // partita vera. Con un pallone dentro si confondeva con Sport.
  virtual: (
    <>
      <rect x="2.6" y="4.4" width="18.8" height="13" rx="2.4" />
      <path d="M10.4 9.1l4 2.8-4 2.8z" />
      <path d="M9 20.6h6" />
    </>
  ),
  // La curva che sale e si spezza: il moltiplicatore dei crash game, che
  // cresce finche' non salta.
  crash: (
    <>
      <path d="M3.5 20.5h17" />
      <path d="M3.5 20.5V3.5" />
      <path d="M6 18c5 0 9-3.5 11.5-10" />
      <path d="M15.2 6.4l2.6 1.4 1.2-2.7" />
    </>
  ),
};

/* Il nome arriva dal campo `img` del menu, che sono gia' quelli dei file
   vecchi: sport, livesport, livecasino, casino, poker, virtual (piu' crash,
   che non ha un file). Se un domani
   ne compare uno che qui non c'e', questa torna nulla e chi la usa ripiega
   sull'immagine di prima - non disegna un'icona a caso. */
function IconaGioco({ nome, className }) {
  const disegno = DISEGNI[nome];
  if (!disegno) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {disegno}
    </svg>
  );
}

export function esisteIcona(nome) {
  return Object.prototype.hasOwnProperty.call(DISEGNI, nome);
}

export default IconaGioco;
